module.exports = __webpack_public_path__ + "src/assets/img/bar-menu2.74c50062.jpg";